import React from 'react';
import { Box, Card, CardContent, Skeleton, Grid } from '@mui/material';

export const DashboardSkeleton: React.FC = () => (
  <Box sx={{ p: 3 }}>
    <Skeleton variant="text" width={200} height={40} sx={{ mb: 3 }} />
    <Grid container spacing={3}>
      {[1, 2, 3, 4].map((i) => (
        <Grid item xs={12} sm={6} md={3} key={i}>
          <Card>
            <CardContent>
              <Skeleton variant="text" width="60%" />
              <Skeleton variant="text" width="40%" height={40} />
              <Skeleton variant="text" width="50%" />
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
    <Box sx={{ mt: 3 }}>
      <Skeleton variant="rectangular" height={300} sx={{ borderRadius: 2 }} />
    </Box>
  </Box>
);

export const PayeeCardSkeleton: React.FC = () => (
  <Card>
    <CardContent sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <Skeleton variant="circular" width={48} height={48} />
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width="60%" />
          <Skeleton variant="text" width="40%" />
        </Box>
      </Box>
      <Skeleton variant="text" width="80%" />
      <Skeleton variant="text" width="70%" />
      <Skeleton variant="text" width="50%" />
      <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
        <Skeleton
          variant="rectangular"
          width={80}
          height={32}
          sx={{ borderRadius: 1 }}
        />
        <Skeleton
          variant="rectangular"
          width={80}
          height={32}
          sx={{ borderRadius: 1 }}
        />
      </Box>
    </CardContent>
  </Card>
);

export const DataTableSkeleton: React.FC = () => (
  <Box>
    <Skeleton
      variant="rectangular"
      height={56}
      sx={{ mb: 1, borderRadius: 1 }}
    />
    {[1, 2, 3, 4, 5].map((i) => (
      <Skeleton
        key={i}
        variant="rectangular"
        height={52}
        sx={{ mb: 0.5, borderRadius: 1 }}
      />
    ))}
  </Box>
);

export const FormSkeleton: React.FC = () => (
  <Box sx={{ p: 3 }}>
    <Skeleton variant="text" width={200} height={40} sx={{ mb: 3 }} />
    <Grid container spacing={2}>
      {[1, 2, 3, 4, 5, 6].map((i) => (
        <Grid item xs={12} sm={6} key={i}>
          <Skeleton variant="text" width="30%" height={20} sx={{ mb: 1 }} />
          <Skeleton
            variant="rectangular"
            height={56}
            sx={{ borderRadius: 1 }}
          />
        </Grid>
      ))}
    </Grid>
    <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
      <Skeleton
        variant="rectangular"
        width={120}
        height={42}
        sx={{ borderRadius: 1 }}
      />
      <Skeleton
        variant="rectangular"
        width={120}
        height={42}
        sx={{ borderRadius: 1 }}
      />
    </Box>
  </Box>
);
